import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import withRouter from "../Components/Common/withRouter";

//import Components
import Header from "./Header";
import CaspSidebar from "../CaspLayout/sidebar";
// import Sidebar from "./Sidebar";
// import Sidebar2 from "./sidebar2";
// import SidebarNew from "./SidebarNew";
// import Sidebar3 from "./Sidebar3";
// import Sidebar4 from "./Sidebar4";
// import Sidebar5 from "./Sidebar5";
import Footer from "./Footer";
import RightSidebar from "../Components/Common/RightSidebar";

//import actions
import {
  changeLayout,
  changeSidebarTheme,
  changeLayoutMode,
  changeLayoutWidth,
  changeLayoutPosition,
  changeTopbarTheme,
  changeLeftsidebarSizeType,
  changeLeftsidebarViewType,
  changeSidebarImageType,
} from "../store/actions";

//redux
import { useSelector, useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";
import { Role } from "../constants/Role";

const Layout = (props) => {
  const [headerClass, setHeaderClass] = useState("");
  const location = useLocation();
  const projectRole = useSelector((state => state.Roles.currentProjectRole))
  const [isFixMenu, setIsFixedMenu] = useState(false)

  const [sidebar1, setSidebar1] = useState(false);
  const [sidebar2, setSidebar2] = useState(false);
  const [sidebar3, setSidebar3] = useState(false);
  const [sidebar4, setSidebar4] = useState(false);
  const [sidebar5, setSidebar5] = useState(false);
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);

  const toggleSidebarCollapse = () => {
    setIsSidebarCollapsed(!isSidebarCollapsed);
  };
  const dispatch = useDispatch();
  const {
    layoutType,
    leftSidebarType,
    layoutModeType,
    layoutWidthType,
    layoutPositionType,
    topbarThemeType,
    leftsidbarSizeType,
    leftSidebarViewType,
    leftSidebarImageType,
  } = useSelector((state) => ({
    layoutType: state.Layout.layoutType,
    leftSidebarType: state.Layout.leftSidebarType,
    layoutModeType: state.Layout.layoutModeType,
    layoutWidthType: state.Layout.layoutWidthType,
    layoutPositionType: state.Layout.layoutPositionType,
    topbarThemeType: state.Layout.topbarThemeType,
    leftsidbarSizeType: state.Layout.leftsidbarSizeType,
    leftSidebarViewType: state.Layout.leftSidebarViewType,
    leftSidebarImageType: state.Layout.leftSidebarImageType,
  }));

  const { pathname } = location;
  const pageClassName = pathname.substring(1);
  const [open, setOpen] = React.useState(false);

  /*
    layout settings
    */
  useEffect(() => {
    if (
      layoutType ||
      leftSidebarType ||
      layoutModeType ||
      layoutWidthType ||
      layoutPositionType ||
      topbarThemeType ||
      leftsidbarSizeType ||
      leftSidebarViewType ||
      leftSidebarImageType
    ) {
      dispatch(changeLeftsidebarViewType(leftSidebarViewType));
      dispatch(changeLeftsidebarSizeType(leftsidbarSizeType));
      dispatch(changeSidebarTheme(leftSidebarType));
      dispatch(changeLayoutMode(layoutModeType));
      dispatch(changeLayoutWidth(layoutWidthType));
      dispatch(changeLayoutPosition(layoutPositionType));
      dispatch(changeTopbarTheme(topbarThemeType));
      dispatch(changeLayout(layoutType));
      dispatch(changeSidebarImageType(leftSidebarImageType));
    }
  }, [
    layoutType,
    leftSidebarType,
    layoutModeType,
    layoutWidthType,
    layoutPositionType,
    topbarThemeType,
    leftsidbarSizeType,
    leftSidebarViewType,
    leftSidebarImageType,
    dispatch,
  ]);
  /*
    call dark/light mode
    */
  const onChangeLayoutMode = (value) => {
    if (changeLayoutMode) {
      dispatch(changeLayoutMode(value));
    }
  };

  // class add remove in header
  useEffect(() => {
    window.addEventListener("scroll", scrollNavigation, true);
  });

  // useEffect(() => {
  //   console.log('project role', projectRole?.role)
  //   if (projectRole?.role) {
  //     setIsFixedMenu([Role.EPMO_OFFICER, Role.ROOT_ADMIN, Role.EPMO_MANAGER, Role.PORTFOLIO_MANAGER, Role.PROGRAM_MANAGER, Role.VICE_PRESIDENT, Role.PRESIDENT].includes(projectRole?.role))
  //   }
  // }, [projectRole])

  // useEffect(() => {
  //   const obj = JSON.parse(sessionStorage.getItem("authUser"));
  //   // console.log(obj)
  //   // if (obj.user.role.name=="VP") {
  //   //   setSidebar1(true);
  //   // }
  //   // if (obj.user.role.name=="EPMO") {
  //   //   setSidebar1(true);
  //   // }

  //   // if (window.location.pathname === "/project-details") {
  //   //   setSidebar2(true);
  //   //   // setSidebar3(true);
  //   //   // setSidebar1(false);
  //   // }

  //   // if (obj.user.role.name=="project-manager") {
  //   //   setSidebar3(true);
  //   // }
  //   // else {
  //   //   setSidebar1(true);
  //   // }
  //   // if (window.location.pathname === "/pending-project-details") {
  //   //   setSidebar3(true);
  //   // }
  //   // if (window.location.pathname === "/new-project") {
  //   //   setSidebar3(true);
  //   // }
  //   // if (window.location.pathname === "/work-Management-dashboard") {
  //   //   setSidebar3(true);
  //   // // }
  //   // if (window.location.pathname === "/work-Management") {
  //   //   setSidebar3(true);
  //   // }
  //   if (window.location.pathname === "/project-epmo-dashboard") {
  //     // setSidebar2(true);
  //     // setSidebar3(true)
  //     // setSidebar4(true)
  //     setSidebar1(true);
  //     //  window.reload()
  //   } else if (window.location.pathname === "/board") {
  //     // setSidebar2(true);
  //     // setSidebar3(true)
  //     // setSidebar4(true)
  //     setSidebar2(true);
  //     // setSidebar1(false);
  //     // window.location.reload()
  //   } else {
  //     setSidebar2(true);
  //   }
  //   // if (obj.user.role.name == "project-sponsor") {
  //   //   //  console.log("123")
  //   //   setSidebar2(true);
  //   // }
  //   // if (obj.user.role.name== "VP") {
  //   //   setSidebar5(true);
  //   // }
  // }, [sidebar1, sidebar2]);

  useEffect(() => {
    if (location.pathname === "/board") {
      setSidebar2(true);
    } else if (location.pathname === "/project-list") {
      setSidebar1(true);
    } else if (location.pathname === "/user-management") {
      setSidebar1(true);
    }
    else if (location.pathname === "/projects") {
      setSidebar1(true);
    }
    else if (location.pathname === "/pending-projects") {
      setSidebar1(true);
    }
    else if (location.pathname === "/calendar") {
      setSidebar1(true);
    }
    else if (location.pathname === "/") {
      setSidebar1(true);
    } 
    else {
      setSidebar2(true);
    }
  }, 
  [location])
  ;

  function scrollNavigation() {
    var scrollup = document.documentElement.scrollTop;
    if (scrollup > 50) {
      setHeaderClass("topbar-shadow");
    } else {
      setHeaderClass("");
    }
  }

  return (
    <React.Fragment>
      <div id="layout-wrapper">
        <Header
          layoutModeType={layoutModeType}
          onChangeLayoutMode={onChangeLayoutMode}
          onMenuIconClick={toggleSidebarCollapse}
        />
        <CaspSidebar isCollapsed={isSidebarCollapsed} />
        {/* <CaspSidebar layoutType={layoutType} open={open} /> */}
       
        {/* <Sidebar layoutType={layoutType} /> */}

        {/* {(sidebar1 && ["/project-list","/projects","/pending-projects","/user-management", "/to-do-list"].includes(location.pathname)) ? <Sidebar layoutType={layoutType}  /> : null} */}


        {/* {sidebar2 ? <SidebarNew layoutType={layoutType} /> : null} */}
        {/* {sidebar2 && !["/project-list","/projects","/pending-projects","/user-management"].includes(location.pathname) ? <Sidebar2 layoutType={layoutType} /> : null} */}
        {/* {sidebar3 ? <Sidebar3 layoutType={layoutType} /> : null}

        {sidebar4 ? <Sidebar4 layoutType={layoutType} /> : null}

        {sidebar5 ? <Sidebar5 layoutType={layoutType} /> : null} */}

        {/* {window.location.pathname === "/project-details" ? (
          <SidebarNew layoutType={layoutType} />
        ) : (
          <Sidebar layoutType={layoutType} />
        )} */}
        <div className={`main-content ${pageClassName}`} style={{ marginLeft: isSidebarCollapsed ? '60px' : '280px' }}>
          {props.children}
          {/* <Footer /> */}
        </div>
      </div>
      <RightSidebar />
    </React.Fragment>
  );
};

Layout.propTypes = {
  children: PropTypes.any,
};

export default withRouter(Layout);
